<template>
  <footer class="footer p-0 mt-lg-2 mt-5">
    <div class="container">
      <nav>
        <ul>
          <!-- <li>
            <a href="https://www.creative-tim.com">Creative Tim</a>
          </li> -->
          <li>
            <a href="https://github.com/shinco0327">
              Meet us on Github
            </a>
          </li>
          <!-- <li>
            <a href="http://blog.creative-tim.com">
              About
            </a>
          </li> -->
          <!-- <li>
            <a href="https://www.creative-tim.com/license">
              Licenses
            </a>
          </li> -->
        </ul>
      </nav>
      <div class="copyright text-center d-flex p-0">
        <p>By YuShan Huang</p>
        <label class="ms-2">國立台灣科技大學電機工程系</label>
        <!-- &copy; {{ new Date().getFullYear() }}
        <a href="https://www.creative-tim.com/?ref=mdf-vuejs" target="_blank"
          >Creative Tim</a
        >, made with <i class="fa fa-heart heart"></i> for a better web -->
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
